// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1L5 5L9 1%27 stroke=%27%23404040%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExchangeSelection_tableContainer__RepO3 {
    margin: 20px;
}

.ExchangeSelection_table__1thqL {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    margin: 20px 0;
    background: white;
}

.ExchangeSelection_table__1thqL th {
    background: #fd5e63;
    color: white;
    font-weight: 500;
    padding: 15px;
    font-size: 14px;
    text-align: center;
    border: none;
}

.ExchangeSelection_table__1thqL td {
    padding: 15px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
    color: #404040;
}

.ExchangeSelection_table__1thqL tr:last-child td {
    border-bottom: none;
}

.ExchangeSelection_table__1thqL tr:hover td {
    background-color: #fff5f5;
}

/* Checkbox styling */
.ExchangeSelection_table__1thqL input[type="checkbox"] {
    width: 14px;
    height: 14px;
    cursor: pointer;
    accent-color: #f7595f;
}

/* Customer Classification */
.ExchangeSelection_radioGroup__9Fi3z {
    display: flex;
    flex-wrap: nowrap;
    gap: 30px;
    margin: 15px 0;
    align-items: center;
}

.ExchangeSelection_radioLabel__rAnrB input[type="radio"] {
    width: 16px;
    height: 16px;
    accent-color: #fd5e63;
}

/* Tariff Sheet Link */
.ExchangeSelection_tariffLink__meTLu {
    display: inline-flex;
    align-items: center;
    padding: 8px 20px;
    background: #fff5f5;
    color: #fd5e63;
    text-decoration: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
    border: 1px solid #ffd1d3;
}

.ExchangeSelection_tariffLink__meTLu:hover {
    background: #ffd1d3;
    transform: translateY(-1px);
}

/* Financial Proof Section */
.ExchangeSelection_customDropdown__I2ZPf {
    width: 300px;
    padding: 8px 35px 8px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 14px;
    color: #404040;
    background-color: white;
    cursor: pointer;
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 15px center;
}

.ExchangeSelection_customDropdown__I2ZPf:focus {
    outline: none;
    border-color: #fd5e63;
}

.ExchangeSelection_proofRow__qxxul {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 20px;
    padding: 15px;
    background: #f9f9f9;
    border-radius: 8px;
}

.ExchangeSelection_proofRow__qxxul .ExchangeSelection_fileInfo__wsHNZ {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    background: #fff;
    border-radius: 4px;
    font-size: 14px;
    color: #404040;
}

.ExchangeSelection_proofRow__qxxul .ExchangeSelection_fileInfo__wsHNZ .ExchangeSelection_fileName__xqog2 {
    color: #fd5e63;
    font-weight: 500;
}

.ExchangeSelection_errorMessage__KKU13 {
    color: #fd5e63;
    font-size: 14px;
    margin: 8px 0;
    padding: 8px 12px;
    background: #fff5f5;
    border-radius: 4px;
    border-left: 3px solid #fd5e63;
    display: block;
    width: 100%;
}

.ExchangeSelection_uploadButtonGroup__39HEa {
    display: flex;
    gap: 10px;
}

.ExchangeSelection_uploadButton__XAXB-, .ExchangeSelection_removeButton__ZV5uV, .ExchangeSelection_addButton__82K6d {
    padding: 8px 20px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    border: none;
    transition: all 0.2s;
}

.ExchangeSelection_uploadButton__XAXB-, .ExchangeSelection_addButton__82K6d {
    background: #fd5e63;
    color: white;
}

.ExchangeSelection_uploadButton__XAXB-:hover, .ExchangeSelection_addButton__82K6d:hover {
    background: #f7595f;
}

.ExchangeSelection_removeButton__ZV5uV {
    background: #f0f0f0;
    color: #666;
}

.ExchangeSelection_removeButton__ZV5uV:hover {
    background: #e0e0f0;
}

.ExchangeSelection_proofNote__-HuWU {
    font-size: 13px;
    color: #666;
    margin-top: 8px;
    padding: 8px 12px;
    background: #fff5f5;
    border-radius: 4px;
    border-left: 3px solid #fd5e63;
}

/* Proceed Button */
.ExchangeSelection_buttonContainer__XgAPJ {
    display: flex;
    justify-content: center;
    margin: 30px 0;
}

.ExchangeSelection_proceedButton__vwYp8 {
    padding: 12px 40px;
    background: #fd5e63;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.ExchangeSelection_proceedButton__vwYp8:hover {
    background: #f7595f;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(253, 94, 99, 0.2);
}

.ExchangeSelection_loadingContainer__Di\\+Ej {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    padding: 20px;
}

.ExchangeSelection_spinner__7-PeR {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #fd5e63;
    border-radius: 50%;
    animation: ExchangeSelection_spin__tqr47 1s linear infinite;
    margin-bottom: 15px;
}

@keyframes ExchangeSelection_spin__tqr47 {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.ExchangeSelection_errorContainer__yE0Th {
    text-align: center;
    padding: 20px;
    background: #fff5f5;
    border-radius: 8px;
    margin: 20px;
}

.ExchangeSelection_errorMessage__KKU13 {
    color: #fd5e63;
    margin: 8px 0;
    padding: 8px 12px;
    background: #fff5f5;
    border-radius: 4px;
    border-left: 3px solid #fd5e63;
    display: block;
    width: 100%;
}

.ExchangeSelection_retryButton__dnuO3 {
    background: #fd5e63;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
}

.ExchangeSelection_retryButton__dnuO3:hover {
    background: #f7595f;
    transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 768px) {
    .ExchangeSelection_tableContainer__RepO3 {
        margin: 10px;
        
    }

    .ExchangeSelection_tableWrapper__QiE8E{
        overflow-x: auto;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        margin-top: -20px;
    }

    .ExchangeSelection_table__1thqL {
        min-width: 600px;
        
    }

    .ExchangeSelection_proofRow__qxxul {
        flex-direction: column;
        align-items: stretch;
    }

    .ExchangeSelection_uploadButtonGroup__39HEa {
        margin-top: 10px;
    }

    .ExchangeSelection_customDropdown__I2ZPf {
        width: 100%;
    }

    .ExchangeSelection_radioGroup__9Fi3z {
        flex-direction: column;
        gap: 15px;
    }
}


@media (max-width: 768px) {
    .ExchangeSelection_radioGroup__9Fi3z {
        gap: 20px;
        justify-content: flex-start;
        flex-direction: row;
    }

    .ExchangeSelection_radioLabel__rAnrB {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        font-size: 14px;
        color: #404040;
    }
}


/* Form Validation */
.ExchangeSelection_invalidField__VqeYn {
    border-color: #fd5e63;
    background-color: #fff5f5;
}

.ExchangeSelection_validationMessage__Tgjwm {
    color: #fd5e63;
    font-size: 12px;
    margin-top: 5px;
}

/* Customer Classification Radio Buttons */
.ExchangeSelection_radioGroup__9Fi3z input[type="radio"]:checked + span {
    color: #fd5e63;
    font-weight: 500;
}

/* Financial Proof Section */
.ExchangeSelection_proofSection__8hQII {
    background: #f9f9f9;
    border-radius: 8px;
    padding: 20px;
    margin-top: 20px;
    position: relative;
}

.ExchangeSelection_proofHeader__V4ymy {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.ExchangeSelection_requiredField__quGpN {
    color: #fd5e63;
    font-size: 12px;
    margin-left: 5px;
}

/* Financial Proof Warning */
.ExchangeSelection_financialWarning__xxbEI {
    margin-top: 15px;
    padding: 15px;
    background: #fff5f5;
    border-radius: 8px;
    border-left: 4px solid #fd5e63;
    color: #fd5e63;
    font-size: 14px;
    font-weight: 500;
}

.ExchangeSelection_uploadButton__XAXB- {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 20px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    border: none;
    transition: all 0.2s;
    background: #fd5e63;
    color: white;
}

.ExchangeSelection_syncIcon__d1HCg {
    width: 16px;
    height: 16px;
    margin-right: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/ExchangeSelection.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,4BAA4B;AAC5B;IACI,YAAY;IACZ,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yDAAwQ;IACxQ,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,2DAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI;QACI,YAAY;;IAEhB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,UAAU;QACV,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;;IAEpB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;;AAGA;IACI;QACI,SAAS;QACT,2BAA2B;QAC3B,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,eAAe;QACf,eAAe;QACf,cAAc;IAClB;AACJ;;;AAGA,oBAAoB;AACpB;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,0CAA0C;AAC1C;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".tableContainer {\n    margin: 20px;\n}\n\n.table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    margin: 20px 0;\n    background: white;\n}\n\n.table th {\n    background: #fd5e63;\n    color: white;\n    font-weight: 500;\n    padding: 15px;\n    font-size: 14px;\n    text-align: center;\n    border: none;\n}\n\n.table td {\n    padding: 15px;\n    text-align: center;\n    border-bottom: 1px solid #f0f0f0;\n    font-size: 14px;\n    color: #404040;\n}\n\n.table tr:last-child td {\n    border-bottom: none;\n}\n\n.table tr:hover td {\n    background-color: #fff5f5;\n}\n\n/* Checkbox styling */\n.table input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    cursor: pointer;\n    accent-color: #f7595f;\n}\n\n/* Customer Classification */\n.radioGroup {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 30px;\n    margin: 15px 0;\n    align-items: center;\n}\n\n.radioLabel input[type=\"radio\"] {\n    width: 16px;\n    height: 16px;\n    accent-color: #fd5e63;\n}\n\n/* Tariff Sheet Link */\n.tariffLink {\n    display: inline-flex;\n    align-items: center;\n    padding: 8px 20px;\n    background: #fff5f5;\n    color: #fd5e63;\n    text-decoration: none;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s;\n    border: 1px solid #ffd1d3;\n}\n\n.tariffLink:hover {\n    background: #ffd1d3;\n    transform: translateY(-1px);\n}\n\n/* Financial Proof Section */\n.customDropdown {\n    width: 300px;\n    padding: 8px 35px 8px 12px;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    font-size: 14px;\n    color: #404040;\n    background-color: white;\n    cursor: pointer;\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23404040' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 15px center;\n}\n\n.customDropdown:focus {\n    outline: none;\n    border-color: #fd5e63;\n}\n\n.proofRow {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-bottom: 20px;\n    padding: 15px;\n    background: #f9f9f9;\n    border-radius: 8px;\n}\n\n.proofRow .fileInfo {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 12px;\n    background: #fff;\n    border-radius: 4px;\n    font-size: 14px;\n    color: #404040;\n}\n\n.proofRow .fileInfo .fileName {\n    color: #fd5e63;\n    font-weight: 500;\n}\n\n.errorMessage {\n    color: #fd5e63;\n    font-size: 14px;\n    margin: 8px 0;\n    padding: 8px 12px;\n    background: #fff5f5;\n    border-radius: 4px;\n    border-left: 3px solid #fd5e63;\n    display: block;\n    width: 100%;\n}\n\n.uploadButtonGroup {\n    display: flex;\n    gap: 10px;\n}\n\n.uploadButton, .removeButton, .addButton {\n    padding: 8px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    border: none;\n    transition: all 0.2s;\n}\n\n.uploadButton, .addButton {\n    background: #fd5e63;\n    color: white;\n}\n\n.uploadButton:hover, .addButton:hover {\n    background: #f7595f;\n}\n\n.removeButton {\n    background: #f0f0f0;\n    color: #666;\n}\n\n.removeButton:hover {\n    background: #e0e0f0;\n}\n\n.proofNote {\n    font-size: 13px;\n    color: #666;\n    margin-top: 8px;\n    padding: 8px 12px;\n    background: #fff5f5;\n    border-radius: 4px;\n    border-left: 3px solid #fd5e63;\n}\n\n/* Proceed Button */\n.buttonContainer {\n    display: flex;\n    justify-content: center;\n    margin: 30px 0;\n}\n\n.proceedButton {\n    padding: 12px 40px;\n    background: #fd5e63;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.proceedButton:hover {\n    background: #f7595f;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(253, 94, 99, 0.2);\n}\n\n.loadingContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 200px;\n    padding: 20px;\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #f3f3f3;\n    border-top: 3px solid #fd5e63;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 15px;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.errorContainer {\n    text-align: center;\n    padding: 20px;\n    background: #fff5f5;\n    border-radius: 8px;\n    margin: 20px;\n}\n\n.errorMessage {\n    color: #fd5e63;\n    margin: 8px 0;\n    padding: 8px 12px;\n    background: #fff5f5;\n    border-radius: 4px;\n    border-left: 3px solid #fd5e63;\n    display: block;\n    width: 100%;\n}\n\n.retryButton {\n    background: #fd5e63;\n    color: white;\n    border: none;\n    padding: 8px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.retryButton:hover {\n    background: #f7595f;\n    transform: translateY(-1px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .tableContainer {\n        margin: 10px;\n        \n    }\n\n    .tableWrapper{\n        overflow-x: auto;\n        margin: 0;\n        padding: 0;\n        box-sizing: border-box;\n        margin-top: -20px;\n    }\n\n    .table {\n        min-width: 600px;\n        \n    }\n\n    .proofRow {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .uploadButtonGroup {\n        margin-top: 10px;\n    }\n\n    .customDropdown {\n        width: 100%;\n    }\n\n    .radioGroup {\n        flex-direction: column;\n        gap: 15px;\n    }\n}\n\n\n@media (max-width: 768px) {\n    .radioGroup {\n        gap: 20px;\n        justify-content: flex-start;\n        flex-direction: row;\n    }\n\n    .radioLabel {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        cursor: pointer;\n        font-size: 14px;\n        color: #404040;\n    }\n}\n\n\n/* Form Validation */\n.invalidField {\n    border-color: #fd5e63;\n    background-color: #fff5f5;\n}\n\n.validationMessage {\n    color: #fd5e63;\n    font-size: 12px;\n    margin-top: 5px;\n}\n\n/* Customer Classification Radio Buttons */\n.radioGroup input[type=\"radio\"]:checked + span {\n    color: #fd5e63;\n    font-weight: 500;\n}\n\n/* Financial Proof Section */\n.proofSection {\n    background: #f9f9f9;\n    border-radius: 8px;\n    padding: 20px;\n    margin-top: 20px;\n    position: relative;\n}\n\n.proofHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.requiredField {\n    color: #fd5e63;\n    font-size: 12px;\n    margin-left: 5px;\n}\n\n/* Financial Proof Warning */\n.financialWarning {\n    margin-top: 15px;\n    padding: 15px;\n    background: #fff5f5;\n    border-radius: 8px;\n    border-left: 4px solid #fd5e63;\n    color: #fd5e63;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.uploadButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 8px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    border: none;\n    transition: all 0.2s;\n    background: #fd5e63;\n    color: white;\n}\n\n.syncIcon {\n    width: 16px;\n    height: 16px;\n    margin-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `ExchangeSelection_tableContainer__RepO3`,
	"table": `ExchangeSelection_table__1thqL`,
	"radioGroup": `ExchangeSelection_radioGroup__9Fi3z`,
	"radioLabel": `ExchangeSelection_radioLabel__rAnrB`,
	"tariffLink": `ExchangeSelection_tariffLink__meTLu`,
	"customDropdown": `ExchangeSelection_customDropdown__I2ZPf`,
	"proofRow": `ExchangeSelection_proofRow__qxxul`,
	"fileInfo": `ExchangeSelection_fileInfo__wsHNZ`,
	"fileName": `ExchangeSelection_fileName__xqog2`,
	"errorMessage": `ExchangeSelection_errorMessage__KKU13`,
	"uploadButtonGroup": `ExchangeSelection_uploadButtonGroup__39HEa`,
	"uploadButton": `ExchangeSelection_uploadButton__XAXB-`,
	"removeButton": `ExchangeSelection_removeButton__ZV5uV`,
	"addButton": `ExchangeSelection_addButton__82K6d`,
	"proofNote": `ExchangeSelection_proofNote__-HuWU`,
	"buttonContainer": `ExchangeSelection_buttonContainer__XgAPJ`,
	"proceedButton": `ExchangeSelection_proceedButton__vwYp8`,
	"loadingContainer": `ExchangeSelection_loadingContainer__Di+Ej`,
	"spinner": `ExchangeSelection_spinner__7-PeR`,
	"spin": `ExchangeSelection_spin__tqr47`,
	"errorContainer": `ExchangeSelection_errorContainer__yE0Th`,
	"retryButton": `ExchangeSelection_retryButton__dnuO3`,
	"tableWrapper": `ExchangeSelection_tableWrapper__QiE8E`,
	"invalidField": `ExchangeSelection_invalidField__VqeYn`,
	"validationMessage": `ExchangeSelection_validationMessage__Tgjwm`,
	"proofSection": `ExchangeSelection_proofSection__8hQII`,
	"proofHeader": `ExchangeSelection_proofHeader__V4ymy`,
	"requiredField": `ExchangeSelection_requiredField__quGpN`,
	"financialWarning": `ExchangeSelection_financialWarning__xxbEI`,
	"syncIcon": `ExchangeSelection_syncIcon__d1HCg`
};
export default ___CSS_LOADER_EXPORT___;
